module.exports = __webpack_public_path__ + "static/media/nav-reservations-logo.de1f4df7.svg";